import { apiWithBody, apiWithQuery, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { filterInstances } from '@nu-art/ts-common';
import { ApiDef_EHRInstallation, DBDef_EHRInstallation } from '@app/org-shared';
import { ModuleFE_OrderConfiguration } from '../order-configuration/index.js';
export const dispatch_onEHRInstallationChanged = new ThunderDispatcherV3('__onEHRInstallationUpdated');
export class ModuleFE_EHRInstallation_Class extends ModuleFE_BaseApi {
    _v1;
    __searchFilterMapper = (item) => [item.label];
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: filterInstances(items.map(i => ({ _id: i._id, uiLabel: i.label })))
        }]);
    constructor() {
        super(DBDef_EHRInstallation, dispatch_onEHRInstallationChanged);
        this._v1 = {
            getEHRInstallation: apiWithQuery(ApiDef_EHRInstallation._v1.getEHRInstallation),
            deleteInstallation: apiWithBody(ApiDef_EHRInstallation._v1.deleteInstallation, this.onInstallationDeleted),
            copyOrderConfigsFromEHRInstallation: apiWithBody(ApiDef_EHRInstallation._v1.copyOrderConfigsFromEHRInstallation),
        };
    }
    onInstallationDeleted = async (response) => {
        await ModuleFE_OrderConfiguration.onEntriesDeleted(response.EHRInstallationOrders);
        await this.onEntryDeleted(response.installation);
    };
}
export const ModuleFE_EHRInstallation = new ModuleFE_EHRInstallation_Class();
//# sourceMappingURL=ModuleFE_EHRInstallation.js.map